export default "__VITE_ASSET__CUUMS20g__"